import React, { useCallback } from 'react';
import Modal from 'react-modal';
import Button from 'react-bootstrap/Button';
import { FiExternalLink } from 'react-icons/fi';
import Zapi from '../../components/api/api';
import Zcompnfe from '../../components/api/compnfe';
import Zmonitoramento from '../monitoramento/monitoramento';
import ListaRegistros from '../pdvexception/list';
import ListaRegistrosDev from '../pdvexception/listdev';
import ZDashboard from '../monitoramento/dashboard';
import ZUpload from '../monitoramento/upload';
import ZDownload from '../monitoramento/download';
import ServidoresAWS from '../monitoramento/servidoresaws';
import Menu from '../menu';

Modal.setAppElement('#root');

export default function Principal() {
  const openExternalPage = useCallback(() => {
    window.open('https://csdash-alpha.vercel.app/', '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <>
      <Menu />
      <div id="cs-layout">
        {/* Sidebar fixa */}
        <div id="cs-sidebar">
          <div className="d-flex flex-column gap-1 py-1">
            {/* AWS Próprio */}
            <div>
              <span className="cs-section-label">AWS Próprio</span>
              <div className="cs-card">
                <div className="px-2 py-1">
                  <ServidoresAWS />
                </div>
              </div>
            </div>

            {/* AWS Compsoft */}
            <div>
              <span className="cs-section-label">AWS Compsoft</span>
              <div className="cs-card">
                {[
                  { label: 'Compnfe/CTe', component: <Zcompnfe /> },
                  { label: 'Zaniboni', component: <Zapi /> },
                  { label: 'Monitor', component: <Zmonitoramento /> },
                  { label: 'Dashboard', component: <ZDashboard /> },
                  { label: 'Upload', component: <ZUpload /> },
                  { label: 'Download', component: <ZDownload /> },
                ].map(({ label, component }) => (
                  <div key={label} className="cs-item">
                    <span className="cs-item-label">{label}</span>
                    <span>{component}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Compsoft */}
            <div>
              <span className="cs-section-label">Compsoft</span>
              <Button
                variant="outline-primary"
                onClick={openExternalPage}
                className="cs-btn-external"
              >
                <FiExternalLink size={11} />
                Acessar CSDash
              </Button>
            </div>
          </div>
        </div>

        {/* Conteúdo principal com scroll */}
        <div id="cs-main">
          <div className="cs-main-card">
            <ListaRegistros />
          </div>
          <div className="cs-main-card">
            <ListaRegistrosDev />
          </div>
        </div>
      </div>
    </>
  );
}